export default __webpack_public_path__ + "static/media/banner4.4940a30f.jpg";